
import React from 'react';

export default function AnnualFeeGuide() {
  const conditions = [
    {
      icon: 'ri-user-line',
      title: '満22歳以下',
      description:
        '入会申込み日時点で満22歳以下の方は、自動的に年会費が実質無料になります。',
      highlight: '年齢条件のみでOK',
    },
    {
      icon: 'ri-shopping-cart-line',
      title: '年間30万円以上利用',
      description:
        '年間のショッピング利用金額が30万円以上で翌年の年会費が実質無料に。月平均25,000円の利用でクリア。',
      highlight: '月2.5万円でクリア',
    },
    {
      icon: 'ri-smartphone-line',
      title: 'ドコモ料金プラン契約',
      description:
        'ドコモ MAX/ポイ活 MAX/ポイ活 20/eximo/ahamo等のプラン契約で初年度の年会費が実質無料。',
      highlight: '初年度のみ適用',
    },
  ];

  return (
    <section className="py-16 bg-gradient-to-br from-[#FFF5F5] to-white">
      <div className="max-w-6xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-center text-[#003366] mb-4">
          年会費実質無料の条件
        </h2>
        <p className="text-center text-gray-600 mb-12">
          以下のいずれかの条件を満たすと、年会費3,300円が実質無料に
        </p>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          {conditions.map((condition) => (
            <div
              key={condition.title}
              className="bg-white rounded-xl shadow-lg p-6 text-center hover:shadow-xl transition-all"
            >
              <div className="w-16 h-16 bg-[#E60033] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${condition.icon} text-3xl text-white`}></i>
              </div>
              <span className="inline-block bg-[#FFD700] text-[#C9002E] text-xs px-3 py-1 rounded-full font-bold mb-3">
                {condition.highlight}
              </span>
              <h3 className="text-xl font-bold text-[#003366] mb-3">{condition.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed">{condition.description}</p>
            </div>
          ))}
        </div>

        {/* 30歳以降の注意 */}
        <div className="bg-[#FFF3CD] border border-[#FFE69C] rounded-xl p-6">
          <div className="flex items-start gap-4">
            <div className="w-10 h-10 bg-[#FFD700] rounded-full flex items-center justify-center flex-shrink-0">
              <i className="ri-information-line text-xl text-[#856404]"></i>
            </div>
            <div>
              <h4 className="font-bold text-[#856404] mb-2">
                30歳以降のカード切り替えについて
              </h4>
              <p className="text-sm text-[#856404]">
                満30歳以降のカード有効期限満了時に、審査の上、年会費11,000円（税込）のdカード
                GOLDに自動的に切り替わります。dカード GOLDはドコモ料金10%還元など、さらに充実した特典が受けられます。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
